import React from 'react';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { Measured, MeasuredCookieType } from '../../../../Measured';
import Dumbo from '../../../../DeviationViews/Dumbo';
import s from './DeviationPromo.scss';
const DeviationPromo = ({ href, onClick, biData, heading, subheading, deviation, attributionSlot, logoSlot, ctaSlot })=>/*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['root'],
        href: href,
        onClick: onClick,
        biData: biData
    }, /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement("div", {
        className: s['top-section']
    }, deviation && /*#__PURE__*/ React.createElement(Measured, {
        cookieType: MeasuredCookieType.DEVIATION_SIDEBAR_PROMO,
        cookieDim: "width",
        listenOnWindow: true
    }, ({ container, onRef })=>/*#__PURE__*/ React.createElement("div", {
            className: s['deviation-wrapper'],
            ref: onRef
        }, /*#__PURE__*/ React.createElement(Dumbo, {
            deviation: deviation,
            width: container === null || container === void 0 ? void 0 : container.width,
            height: 224,
            "aria-hidden": "true",
            useCoverMode: true
        }), attributionSlot && /*#__PURE__*/ React.createElement("p", {
            className: s['attribution']
        }, attributionSlot))), /*#__PURE__*/ React.createElement(Heading, {
        className: s['heading']
    }, heading), /*#__PURE__*/ React.createElement("p", {
        className: s['description']
    }, subheading)), /*#__PURE__*/ React.createElement("div", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['bottom-section']
    }, logoSlot, ctaSlot)));
DeviationPromo.displayName = 'DeviationPromo';
export default DeviationPromo;
